import { render, staticRenderFns } from "./HousingCompanyInfoView.vue?vue&type=template&id=0116d834&"
import script from "./HousingCompanyInfoView.vue?vue&type=script&lang=ts&"
export * from "./HousingCompanyInfoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports